import Vue from 'vue'
import config from '@/configurations/config-environment'
import { BaseService } from '../baseService'
import moment from 'moment'

const deliveryservice = config.apis.deliveryservice
const dataws = config.apis.dataws

export class LabImportService extends BaseService {
  getLabImportStatus() {
    const data = {
      Authorisation: this.getAuthorizationObject()
    }

    return Vue.http
      .post(`${deliveryservice}LabImportService_V1_0/GetLabImportStatus`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((oldServiceResponse) => {
        return Vue.http
          .post(`${dataws}ITWLabAssignmentRestService_V1_0/GetLabImportStatus`, data, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((newServiceResponse) => {
            let oldServiceSuccess = oldServiceResponse.status === 200 && oldServiceResponse.data.ResultCode === 'Success'
            let newServiceSuccess = newServiceResponse.status === 200 && newServiceResponse.data.ResultCode === 'Success'

            if (!oldServiceSuccess && !newServiceSuccess) throw new Error('Unable to get labimport status')

            if (!oldServiceSuccess) return newServiceResponse.data.labImportStatus
            if (!newServiceSuccess) return oldServiceResponse.data.labImportStatus

            let oldStatus = oldServiceResponse.data.labImportStatus
            let newStatus = newServiceResponse.data.labImportStatus

            // only ArRetrieveLastRun is used
            let newStatusIsNewerThanOld =
              oldStatus.ArRetrieveLastRun === 'null' || (newStatus.ArRetrieveLastRun !== 'null' && moment.utc(newStatus.ArRetrieveLastRun) > moment.utc(oldStatus.ArRetrieveLastRun))

            if (newStatusIsNewerThanOld) {
              oldStatus.ArRetrieveLastRun = newStatus.ArRetrieveLastRun
            }

            return oldStatus
          })
      })
  }

  importLabResults() {
    const data = {
      Authorisation: this.getAuthorizationObject()
    }

    return Vue.http
      .post(`${deliveryservice}LabImportService_V1_0/ImportLabResults`, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((oldServiceResponse) => {
        return Vue.http
          .post(`${dataws}ITWLabAssignmentRestService_V1_0/ImportLabResults`, data, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((newServiceResponse) => {
            let oldServiceSuccess = oldServiceResponse.status === 200 && oldServiceResponse.data.ResultCode === 'Success'
            let newServiceSuccess = newServiceResponse.status === 200 && newServiceResponse.data.ResultCode === 'Success'

            if (!oldServiceSuccess && !newServiceSuccess) throw new Error('Unable to import analysis results')

            return (oldServiceResponse.data.ResultMessage || '') + '\n' + (newServiceResponse.data.ResultMessage || '')
          })
      })
  }
}
